import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { BakeoutsCreate, BakeoutsDelete, BakeoutsRefresh, BakeoutsUpdate } from './bakeouts.action';
import { BakeoutService } from '../../bakeout.service';
import { Bakeout } from '../../bakeouts';
import { readStatusSnapshot, writeStatusSnapshot } from '../../../status-snapshot-cache';

const BAKEOUTS_SNAPSHOT_KEY = 'home:bakeouts:snapshot';

export class BakeoutsStateModel {
  data: Bakeout[] = [];
  loading!: boolean;
}

@State<BakeoutsStateModel>({
  name: 'Bakeouts',
  defaults: {
    data: [],
    loading: false
  }
})
@Injectable()
export class BakeoutsState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: BakeoutService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: BakeoutsStateModel) {
    return state.data;
  }

  @Action(BakeoutsRefresh)
  refresh({ getState, patchState }: StateContext<BakeoutsStateModel>) {
    patchState({ loading: true });

    if (!getState().data?.length) {
      const snapshot = readStatusSnapshot<Bakeout[]>(BAKEOUTS_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ data: snapshot });
    }

    this._service.getAll().toPromise().then(
      data => {
        patchState({ data, loading: false });
        writeStatusSnapshot(BAKEOUTS_SNAPSHOT_KEY, data);
      },
      error => {
        patchState({ loading: false });
        console.error(error);
      }
    );
  }

  @Action(BakeoutsCreate)
  create({ getState, patchState }: StateContext<BakeoutsStateModel>, { item }: BakeoutsCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    const data = [...getState().data, item];
    patchState({ data });
    writeStatusSnapshot(BAKEOUTS_SNAPSHOT_KEY, data);
  }

  @Action(BakeoutsUpdate)
  update({ getState, patchState }: StateContext<BakeoutsStateModel>, { id, item }: BakeoutsUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      const data = [...state.data, item];
      patchState({ data });
      writeStatusSnapshot(BAKEOUTS_SNAPSHOT_KEY, data);
    }
  }

  @Action(BakeoutsDelete)
  delete({ getState, patchState }: StateContext<BakeoutsStateModel>, { id }: BakeoutsDelete) {
    const data = getState().data.filter(x => x.id !== id);
    patchState({ data });
    writeStatusSnapshot(BAKEOUTS_SNAPSHOT_KEY, data);
  }

}
